module.exports = __webpack_public_path__ + "static/media/3 13 Tulleord Starter testen.d86c75be.mp3";